import { TextAreaWithLabel } from '@adotel/components'
import { useMutation } from '@apollo/client'
import { Button, Modal, Paper, Slide, Typography } from '@material-ui/core'
import KeyIcon from '@material-ui/icons/VpnKey'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { GENERATE_CHANNEL_API_KEYS_MUTATION } from '../../graphql/generateChannelAPIKeys'
import { DateObject } from '../../helpers/date'
import { getDirection, getTranslate } from '../../localization'
import { DatePickerInputWithLabel } from '../DatePickerInputWithLabel'
import useStyles from './index.styles'

interface GenerateAPIKeyModalProps {
  isOpen: boolean
  onClose: () => void
  cachedLevels: (
    | {
        label: string
        link: string
      }
    | {
        label: string
        link?: undefined
      }
  )[]
  reloadData: () => void
}

const GenerateAPIKeyModal: React.FC<GenerateAPIKeyModalProps> = ({
  isOpen,
  onClose,
  cachedLevels,
  reloadData
}) => {
  const classes = useStyles()
  const { id } = useParams<{ id: string }>()
  const [description, setdescription] = useState('')
  const [dateObject, setdateObject] = useState<DateObject>({})

  const [mutateFunction, { loading: pendingForGeneration }] = useMutation(
    GENERATE_CHANNEL_API_KEYS_MUTATION
  )
  const onSave = () => {
    mutateFunction({
      variables: {
        input: {
          ExpiresAt: dateObject.gregorianStartDate,
          Description: description,
          ChannelID: id
        }
      }
    })
      .then(({ data: response }) => {
        toast.success(response.generateChannelAPIKey.message)
        onClose()
        reloadData()
      })
      .catch((response) => {
        toast.error(response.message)
      })
  }

  return (
    <Modal open={isOpen} onClose={onClose} dir={getDirection()}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.deletePaper}>
          <KeyIcon className={classes.deleteIcon} color="primary" />
          <Typography variant="h3" className={classes.title}>
            {getTranslate('Generate API Key for')}&nbsp;{cachedLevels[1].label}
          </Typography>
          <DatePickerInputWithLabel
            label={getTranslate('Expiry Date')}
            autoComplete="off"
            inputSize="small"
            datePickerProps={{
              onChange: (d: DateObject) => setdateObject(d),
              range: false,
              dateObject: dateObject,
              numberOfVisibleMonths: 1
            }}
          />
          <TextAreaWithLabel
            label={getTranslate('Description')}
            placeholder={getTranslate('Description')}
            autoComplete="off"
            inputSize="small"
            rows={5}
            value={description}
            onChange={(event) => setdescription(event.currentTarget.value)}
          />
          <div className={classes.buttonsContainer}>
            <Button variant="text" onClick={onClose}>
              {getTranslate('Cancel')}
            </Button>
            <Button
              variant="contained"
              className={classes.deleteButton}
              onClick={onSave}
              color="primary"
              disabled={pendingForGeneration || !dateObject || !description}>
              {getTranslate('Confirm')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default GenerateAPIKeyModal
